import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from "@angular/core";

@Directive({
  selector: "[cdnBgSrc]",
})
export class CdnBackgroundDirective implements OnChanges {
  @Input("cdnBgSrc") src!: string | any[];
  @Input() cdnWidth?: number;
  @Input() cdnHeight?: number;
  @Input() defaultBackground: string = "assets/images/footer-bg.jpg";

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["src"] ||
      changes["cdnWidth"] ||
      changes["cdnHeight"] ||
      changes["defaultBackground"]
    ) {
      this.updateBackground();
    }
  }

  private getBackgroundImage(img: any[]): string {
    if (!img || !Array.isArray(img)) return this.defaultBackground;

    const desktopBanner = img.find((item) => item?.bannerFor === "DESKTOP");

    if (desktopBanner?.bannerImg) {
      return desktopBanner.bannerImg;
    } else {
      return this.defaultBackground;
    }
  }

  private updateBackground(): void {
    let imageUrl: string;

    // Handle array input (your banner structure)
    if (Array.isArray(this.src)) {
      imageUrl = this.getBackgroundImage(this.src);
    } else {
      // Handle string input (direct URL)
      imageUrl = this.src || this.defaultBackground;
    }

    if (!imageUrl) {
      this.renderer.removeStyle(this.el.nativeElement, "background-image");
      return;
    }

    let finalUrl = imageUrl.trim();

    // ✅ Case 1: IQMetrix CDN
    if (finalUrl.startsWith("https://ams.iqmetrix.net/images/")) {
      const base = finalUrl.replace(/\/+$/, "");
      let previewUrl = `${base}/preview`;

      if (this.cdnWidth && this.cdnHeight) {
        previewUrl += `/${this.cdnWidth}/${this.cdnHeight}`;
      } else if (this.cdnWidth) {
        previewUrl += `/${this.cdnWidth}`;
      }

      finalUrl = previewUrl;
    }

    // ✅ Case 2: AWS S3 (Highlife) → CloudFront optimized URL
    else if (finalUrl.includes("cova-common.s3.ca-central-1.amazonaws.com")) {
      const s3Base = "https://cova-common.s3.ca-central-1.amazonaws.com";
      const cloudfrontBase = "https://d1t0ab30i9xkzc.cloudfront.net";
      const relativePath = finalUrl.replace(s3Base + "/", "");

      const width = this.cdnWidth || 800;
      const height = this.cdnHeight || 600;

      finalUrl = `${cloudfrontBase}/fit-in/${width}x${height}/filters:quality(70)/filters:format(webp)/filters:strip_exif()/filters:no_upscale()/${relativePath}`;
    }

    // ✅ Apply as background image
    this.renderer.setStyle(
      this.el.nativeElement,
      "background-image",
      `url('${finalUrl}')`
    );
    this.renderer.setStyle(this.el.nativeElement, "background-size", "cover");
    this.renderer.setStyle(
      this.el.nativeElement,
      "background-position",
      "center"
    );
    this.renderer.setStyle(
      this.el.nativeElement,
      "background-repeat",
      "no-repeat"
    );
  }
}
